import { render, staticRenderFns } from "./messageManagementList.vue?vue&type=template&id=523c0f82&scoped=true"
import script from "./messageManagementList.vue?vue&type=script&lang=js"
export * from "./messageManagementList.vue?vue&type=script&lang=js"
import style0 from "./messageManagementList.vue?vue&type=style&index=0&id=523c0f82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523c0f82",
  null
  
)

export default component.exports